<template>
  <div class="py-2">
    <input
      :id="labelId"
      class="w-full text-xs text-neutral-500 file:mr-3 file:rounded-md file:border file:border-solid file:border-secondary-500 file:bg-white file:py-1 file:px-8 file:text-xs file:font-bold file:text-secondary-500 file:transition-colors file:duration-150 file:ease-out-quart hover:file:cursor-pointer hover:file:border-secondary-300 hover:file:text-secondary-300 active:file:border-secondary-500 active:file:bg-secondary-500 active:file:text-white disabled:file:border-secondary-100 disabled:file:bg-white disabled:file:text-secondary-100"
      type="file"
      :name="name"
      :accept="accept"
      :multiple="multiple"
      :disabled="disabled"
      :required="required"
      @change="onFileChange"
    />
  </div>
</template>

<script lang="ts" setup>
import { inject, ref } from 'vue';
import { FieldLabelIdInjectionKey } from './InfuseFieldInjection';

const emit = defineEmits(['update:modelValue']);

interface Props {
  name?: string;
  modelValue?: FileList | File;
  multiple?: boolean;
  accept?: string;
  disabled?: boolean;
  required?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  name: undefined,
  modelValue: undefined,
  accept: '*'
});

const focus = () => {
  inputElement.value?.focus();
};

defineExpose({ focus });

const labelId = inject(FieldLabelIdInjectionKey, null);

const inputElement = ref<InstanceType<typeof HTMLInputElement> | null>();

function onFileChange(event: Event) {
  let files: FileList | File | undefined = (event.target as HTMLInputElement).files || undefined;
  if (!props.multiple && files) {
    files = files[0];
  }

  emit('update:modelValue', files);
}
</script>
